"use strict";

import PageCommon from "../PageCommon";
import Globals from "../../Globals.js";

export default class ArtistProfile extends PageCommon {
    constructor(props) {
        super();
        this.data = {};
        this.tracks = null;
        this.artists = null;
        this.playlists = null;
        this.countries = null;
    }
    init({ user, tracks, artists, playlists, countries }) {
        super.init();
        user.subscriptions.sort((a, b) => a.dt1 - b.dt1);
        this.data = user;
        this.tracks = tracks;
        this.artists = artists;
        this.playlists = playlists;
        this.countries = countries;
    }

    set(object) {
        this.data = Object.keys(this.data).map((field) => (this.data[field] = object[field]));
    }

    get() {
        return this.data;
    }

    showPage() {
        this.renderPage();
        this.setupEvents();
    }

    setupEvents() {
        const _this = this;
        Array.from(document.querySelectorAll(".user-main-info .btn-edit")).map((button) => {
            button.addEventListener("click", () => {
                _this.updateEditModal();
            });
        });
        document.querySelector(".user-main-info .wrapper-img").addEventListener("click", () => {
            _this.updateEditModal();
        });

        const modalId = "#artistProfileEditModal";
        const modal = document.querySelector(modalId);
        modal.querySelector(".save").addEventListener("click", () => {
            _this.artist.name = modal.querySelector(".artist-name").value;
            _this.artist.description = modal.querySelector(".artist-description").value;
            _this.sendUpdateProfile();
        });
        modal.querySelector(".file-input").addEventListener("change", (event) => {
            const preview = modal.querySelector(".imagePreview");
            const file = event.target.files[0];
            this.avatarFile = file;
            const reader = new FileReader();
            reader.onload = (event) => {
                preview.style.backgroundImage = `url('${event.target.result}')`;
                this.data.avatar = event.target.result;
            };
            reader.readAsDataURL(file);
        });
    }

    renderPage() {
        const token = this.getCookie("user_token");
        if (this.data && this.data.is_artist && token) {
            fetch(`${Globals.WS_URL}?mode=ARTISTDATA&token=${token}`)
                .then(this.handleResponse)
                .then((result) => {
                    if (Globals.SHOW_ALL_CONSOLE_LOG) console.log(result);
                    if (result.artist && result.artist.ID !== 0) {
                        this.artist = result.artist;
                        this.artist.Image.Medium = this.artist.Image.Medium.replace(/\s/g, "%20");
                        this.artist.Image.High = this.artist.Image.High.replace(/\s/g, "%20");
                        this.artist.Wallpaper = this.artist.Wallpaper.replace(/\s/g, "%20");
                        this.renderDetails();
                        this.renderPlaylists();
                        this.renderTracks();
                        this.renderDocuments();
                    } else {
                        window.location.href = "/find-music";
                    }
                })
                .catch((error) => {
                    Globals.SHOW_ALL_CONSOLE_LOG && console.log("Artist Profile - Render Page", { message: error.message });
                    jQuery(".js-critical-error").show();
                });
        } else {
            window.location.href = "/find-music";
        }
    }

    renderDetails() {
        const detail = document.querySelector(".user-main-info");
        const image = detail.querySelector(".wrapper-img");
        const name = detail.querySelector(".album-name");
        const description = detail.querySelector(".album-bio .extract-description");

        name.textContent = `${this.artist.name}`;
        description.textContent = this.artist.description;

        if (image.querySelector("img")) {
            image.querySelector("img").src = this.artist.Image.Medium;
        } else {
            const imageEl = new Image();
            imageEl.src = this.artist.Image.Medium;
            image.appendChild(imageEl);
        }
    }

    renderTracks() {
        const tracks = document.querySelector(".licenses-history");
        const tracksList = tracks.querySelector(".tracks-list .tracks-list-body");

        // this.artist.tracks = [
        //     {
        //         id: 38,
        //         download_count: 0,
        //         play_count: 0,
        //         playlist_count: 0,
        //     },
        // ];
        this.artist.tracks.map((trackObj) => {
            const track = this.tracks.get({ id: trackObj.id });
            if (track) {
                const trackItem = document.querySelector("#model-artist-profile-track-item .track-item").cloneNode(true);
                trackItem.querySelector(".title").textContent = track.data.Name;
                trackItem.querySelector(".downloads").textContent = trackObj.download_count;
                trackItem.querySelector(".plays").textContent = trackObj.play_count;
                trackItem.querySelector(".playlists").textContent = trackObj.playlist_count;
                tracksList.appendChild(trackItem);
            }
        });
    }

    renderPlaylists() {
        const playlists = document.querySelector(".playlists-history");
        const playlistsList = playlists.querySelector(".swiper-wrapper");

        // this.artist.playlist = [1986];
        this.artist.playlist.map((playlistID) => {
            const playlist = this.playlists.get({ id: playlistID });
            if (playlist) {
                playlistsList.appendChild(playlist.renderSwiperListItem());
            }
        });
    }

    renderDocuments() {
        const documents = document.querySelector(".documents-history");
        const documentsList = documents.querySelector(".tracks-list .tracks-list-body");

        this.artist.documents.map((doc) => {
            const item = document.querySelector("#model-artist-profile-documents-item .track-item").cloneNode(true);

            item.querySelector(".name").textContent = doc.name;
            item.querySelector(".tl-actions a").href = doc.file;

            // 250113 - Disabled reports for now...
            // 250203 - Reenabled reports
            documentsList.appendChild(item); 
        });
    }

    updateEditModal() {
        const modalId = "#artistProfileEditModal";
        const modal = document.querySelector(modalId);
        const image = modal.querySelector(`.user-main-info .wrapper-img`);
        const name = modal.querySelector(`input.artist-name`);
        const description = modal.querySelector(`textarea.artist-description`);

        setTimeout(() => {
            name.value = this.artist.name;
            description.value = this.artist.description;
            image.querySelector(".imagePreview").style.backgroundImage = `url(${this.artist.Image.Medium})`;
        }, 100);
    }

    // sendUpdateProfile() {
    //     const token = this.getCookie("user_token");
    //     const modalId = "#profileUpdateStatusModal";
    //     this.showUpdateStatusModal();
    //     jQuery(modalId).modal("show");
    //     if (token) {
    //         if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Artist Profile - Update");
    //         let url = `${Globals.WS_URL}?mode=ARTISTDATA.UPDATE&token=${token}&artist_data=${JSON.stringify(this.artist)}`;
    //         if (this.avatar) {
    //             url += `&avatar="${this.avatar}"`;
    //         }
    //         fetch(url)
    //             .then(this.handleResponse)
    //             .then((result) => {
    //                 if (Globals.SHOW_ALL_CONSOLE_LOG) console.log(result);
    //                 if (result.updated) {
    //                     if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Artist Profile - Update OK");
    //                     this.renderDetails();
    //                     this.showUpdateStatusModal("Updated");
    //                     setTimeout(() => jQuery(modalId).modal("hide"), 2000);
    //                 }
    //             })
    //             .catch((error) => Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message }));
    //     } else {
    //         if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Artist Profile Update - Token NOT present");
    //     }
    // }

    sendUpdateProfile() {
        const token = this.getCookie("user_token");
        const modalId = "#artistProfileUpdateStatusModal";
        this.showUpdateStatusModal("");
        jQuery(modalId).modal("show");
        if (token) {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Artist Profile - Update");
            const data = {
                token,
                artist_data: JSON.stringify({
                    ID: this.artist.ID,
                    name: this.artist.name,
                    description: this.artist.description,
                }),
                avatar: this.avatarFile,
            };

            let url = `${Globals.WS_URL}?mode=ARTISTDATA.UPDATE`;

            const formData = new FormData();

            for (const name in data) {
                formData.append(name, data[name]);
            }

            const args = {
                method: "POST",
                header: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: formData,
            };

            fetch(url, args)
                .then(this.handleResponse)
                .then((result) => {
                    if (Globals.SHOW_ALL_CONSOLE_LOG) console.log(result);
                    if (result.updated) {
                        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Artist Profile - Update OK");
                        this.renderDetails();
                        this.showUpdateStatusModal("Updated");
                        setTimeout(() => jQuery(modalId).modal("hide"), 2000);
                    } else {
                        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Artist Profile - Update ERROR");
                        this.showUpdateStatusModal("ERROR");
                    }
                })
                .catch((error) => {
                    Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message });
                    jQuery(".js-critical-error").show();
                });
        } else {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Artist Profile Update - Token NOT present");
        }
    }

    showUpdateStatusModal(text) {
        const modalId = "#profileUpdateStatusModal";
        const modal = document.querySelector(modalId);
        const message = modal.querySelector(`.message`);
        if (text) {
            jQuery(`${modalId} .js-preloader`).hide();
            message.textContent = text;
        } else {
            jQuery(`${modalId} .js-preloader`).show();
        }
    }

    dispose() {
        this.data = {};
    }
}
